import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面未找到 - 飘花电影网",
    description: "抱歉，您访问的页面不存在或已被移除。返回飘花电影网首页继续浏览影视内容。",
    keywords: "404,页面未找到,飘花电影网",
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-100">
      <SiteHeader />
      <main className="mx-auto flex w-full max-w-[1200px] flex-1 flex-col items-center justify-center px-4 py-20 text-center md:px-6">
        <p className="font-heading text-7xl font-black text-primary-200 md:text-9xl">404</p>
        <h1 className="mt-4 font-heading text-xl font-bold text-foreground-900 md:text-2xl">
          抱歉，没有找到这个页面
        </h1>
        <p className="mt-2 font-mono text-sm text-foreground-400">{location.pathname}</p>
        <p className="mt-3 max-w-md text-sm text-foreground-500">
          页面可能已被移除或链接有误，您可以返回首页，或前往电影、电视剧频道继续浏览。
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link to="/" className="whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700">
            返回首页
          </Link>
          <Link to="/movie" className="whitespace-nowrap rounded-md bg-secondary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-700">
            浏览电影
          </Link>
          <Link to="/tv" className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400">
            浏览电视剧
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}